import s from './User.module.css';
import React from "react";
import {chatApi} from "@/api";
import UserImage from "@common/Chat/components/UserImage/UserImage";
import {useAddAlert} from "@/hooks/useAddAlert";
const User = ({user, setPage, activeUsers}) => {
    const isUserOnline = activeUsers.find(id => id === user.id)
    const addAlert=useAddAlert();
    const save =(e) => {
        if((user.type === 'group' || user.type === 'support') && !!user?.id){
           setPage('inChat', user?.id) 
        }
        else{
            chatApi.createChat({
                name: null,
                chatImage: null,
                users: [{...user, role: 1}]
            }).then((res) => {
                if (res.status === 200) {
                    setPage('inChat', res?.data?.id)
                } else {
                    addAlert({text: res?.response?.data?.error})
                }
            })
        }
    }
    return (
        <div className={s.user} onClick={(e) => save(e)}>
            <div className={s.photo}>
                <UserImage path={user.avatar_path}/>
                {isUserOnline && <div className={s.isOnline}></div>}
            </div>

            <div className={s.name}> 
                {user.name}
                {!!user?.statusLabel?.trim() && <span style={{color: 'var(--color-text-soft)'}}> ({user?.statusLabel})</span>}
            </div>
        </div>
    )
}

export default User;